const EditorialSystemId = {
     CropPage : 1,
     Image : 2
}
export default EditorialSystemId;